import type { Editor } from '@tiptap/react';

export const applyDevTools = (editor: Editor, isDebugMode = false) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (/ricos-debug/i.test(window.location.search) || isDebugMode) {
    import(
      /* webpackChunkName: "ricos_prosemirror-dev-tools" */
      'prosemirror-dev-tools'
    ).then(({ applyDevTools }) => {
      applyDevTools(editor.view);
    });
  }
};
